export enum RoleId {
  SITE_OWNER = 1,
  POWER_USER = 2,
  CAMPAIGN_AUTHOR = 3,
  CAMPAIGN_MANAGER = 4,
  REPORT_VIEWER = 5,
  BILLING_MANAGER = 6,
}

const ROLES: Record<RoleId, string> = {
  [RoleId.SITE_OWNER]: 'Site Owner',
  [RoleId.POWER_USER]: 'Power User',
  [RoleId.CAMPAIGN_AUTHOR]: 'Campaign Author',
  [RoleId.CAMPAIGN_MANAGER]: 'Campaign Manager',
  [RoleId.REPORT_VIEWER]: 'Report Viewer',
  [RoleId.BILLING_MANAGER]: 'Billing Manager',
};

export class Role {
  constructor(private readonly roleId: RoleId) {}

  public getRoleId(): RoleId {
    return this.roleId;
  }

  public getRoleName(): string {
    return ROLES[this.roleId];
  }

  public isSiteOwner(): boolean {
    return this.roleId === RoleId.SITE_OWNER;
  }

  public isPowerUser(): boolean {
    return this.roleId === RoleId.POWER_USER;
  }

  public isCampaignAuthor(): boolean {
    return this.roleId === RoleId.CAMPAIGN_AUTHOR;
  }

  public isCampaignManager(): boolean {
    return this.roleId === RoleId.CAMPAIGN_MANAGER;
  }

  public isReportViewer(): boolean {
    return this.roleId === RoleId.REPORT_VIEWER;
  }

  public isBillingManager(): boolean {
    return this.roleId === RoleId.BILLING_MANAGER;
  }

  public canBuyProducts(): boolean {
    return this.isSiteOwner();
  }
}
